/**
 * PostAuthorAvatar 컴포넌트
 * @description 글쓴이 얼굴 — 사진이 있으면 사진, 없으면 첫 글자. 곁글(데스크톱)과 바이라인
 *   (폰·태블릿)이 같은 얼굴을 쓴다.
 */
import { Avatar } from "@fanwork-web/design-system";
import { memo } from "react";

import {
  POST_AUTHOR_AVATAR_SIZE,
  POST_AUTHOR_AVATAR_WIDTH,
} from "./PostDetail.styles";

import type { BlogAuthor } from "../../dtos";
import { AppImage } from "@/shared/ui";

const PostAuthorAvatar = memo<{ author: BlogAuthor }>(({ author }) =>
  author.profileImageUrl ? (
    <Avatar
      type="image"
      size={POST_AUTHOR_AVATAR_SIZE}
      image={
        <AppImage
          uri={author.profileImageUrl}
          targetWidth={POST_AUTHOR_AVATAR_WIDTH}
        />
      }
    />
  ) : (
    <Avatar
      type="initial"
      size={POST_AUTHOR_AVATAR_SIZE}
      initial={author.name.charAt(0).toUpperCase()}
    />
  ),
);

PostAuthorAvatar.displayName = "PostAuthorAvatar";

export default PostAuthorAvatar;
